

<div class="page_device">
  <div class="device">
    <div class="tabHeader">

      <div class="leftHeader">
        <div class="select-block">
          <Select :options="state.op1" v-model:selected="state.selectVal1" @onChange="selectChange"></Select>
        </div>
        <div class="tableVisibility" @mouseover="showEx($event,true)" 
        @mouseleave="showEx($event,false)" ref="hoverDiv">
          <Button @onClick="setTableSort" type="icon" icon="asus_pacc_sw_ico_table_visible" text="" colors="dark1" theme="2" h="mlg"></Button>
          <!-- <iCon iconClass="asus_proart_sw_ico_file_text"></iCon> -->
          <div class="tooltips"   
            :style="itemClass" :class="state.detail ? 'show':'noshow'">
              <div>{{state.detail}}</div>
          </div>
        </div>
      </div>
      
      <div class="buttonGroup">
        <ActionBar class="actionBar" @actionBarClick="actionBarClick" :iconList="state.iconList"></ActionBar>
        <Button @onClick="unbind" type="full" :disable="state.list.length ? false : true"  class="btn-inline"  :text="t('__d4e_m8t.__unbind')" colors="dark1" theme="2" h="mlg"></Button>
        <!-- :disable="state.list.length ? false : true" -->
      </div>
    </div>
  
    <div class="tabMainBlock" :class="{'flexGrowHight': !state.dataList.length }">
      <Table @tableSort="tableSort" :disableCheck="state.disableCheck" :hasContextmenu="true" @goTableLink="goTableLink"
        @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
          :columns="state.showColumn" :data="state.dataList" tablePadding="5" :checkBox="true">
          <template #contextMenu="{position}">
            <CTmenu @selectContextMenu="selectCT" :list="state.ctList" :position="position"></CTmenu>
          </template>
          <template #empty="{text}">
            <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
          </template>
        </Table>
    </div>
  </div>
  <!-- <div>
    {{state.dataList[0]}}
  </div> -->



  <div class="tabFooter" >
    <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current" :range="5" @changePage="changePage"></Pagination>
  </div>



</div>
